<template>
  <div class="users">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Encoding Profiles</span>
        <span slot="link">
          <button-cta class="btn btn-primary pull-right" data-modalType="addEncodingProfile" :onClick="onLaunchModal">
            Add Encoding Profile
          </button-cta>
        </span>
      </heading-wrap>

      <spinner v-if="loading" />
<!--      <h4 v-if="!isAdmin && false" style="padding-top: 10px">Client Bespoke Encoding Profiles</h4>-->
<!--      <slot-table v-if="!isAdmin" :data="associatedClientEncodingProfiles" :columns="table.columns.associated_clients_eps" class="epTable">-->
<!--        <template slot="clients" slot-scope="props">-->
<!--          {{ getNamesFromClientsData(props.item, true) }}-->
<!--        </template>-->
<!--        <template slot="actions" slot-scope="props">-->
<!--              <span @mouseover="setActiveActionSlug (props.item.slug)">-->
<!--                <button-cta data-modalType="assignEncodingProfileToClients" :data-modalID="props.item.id" :data-modalField="props.item.name" :onClick="(event) => launchAssignEPModal(event, props.item)" class="btn btn-primary btn-xs">-->
<!--                    <i :class="getAssignIcon(props.item)" aria-hidden="true"></i>-->
<!--                </button-cta>-->
<!--              </span>-->
<!--        </template>-->
<!--      </slot-table>-->
<!--      <hr v-if="!isAdmin" >-->
      <h4 style="padding-top: 10px">{{ isAdmin ? 'Clients Encoding Profiles': 'My Encoding Profiles'}}</h4>
      <slot-table :data="clientEncodingProfiles" :columns="table.columns.client" class="epTable">
<!--        <template v-if="isAdmin" slot="user" slot-scope="props">-->
<!--          <router-link :to='`/user/${props.item.user.hash_id}/edit`'>-->
<!--            {{ props.item.user.username}}-->
<!--          </router-link>-->
<!--        </template>-->
        <template slot="clients" slot-scope="props">
          {{ getNamesFromClientsData(props.item) }}
        </template>
        <template slot="actions" slot-scope="props">
              <span @mouseover="setActiveActionSlug (props.item.slug)">
                <button-cta data-modalType="assignEncodingProfileToClients" :data-modalID="props.item.id" :data-modalField="props.item.name" :onClick="(event) => launchAssignEPModal(event, props.item)" :theme="getAssignColor(props.item)" class="btn-xs">
                    <i :class="getAssignIcon(props.item)" aria-hidden="true"></i>
                </button-cta>
                <button-cta v-if="isAdmin || props.item.actions" data-modalType="editEncodingProfile" :data-modalID="props.item.id" :data-modalField="props.item.display_name" :data-modalFieldType="props.item.data" :onClick="onLaunchModal" class="btn btn-warning btn-xs">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                </button-cta>
                <button-cta data-modalType="cloneEncodingProfile" :data-modalID="props.item.id" :data-modalField="props.item.name" :onClick="onLaunchModal" class="btn btn-success btn-xs">
                    <i class="fa fa-clone" aria-hidden="true"></i>
                </button-cta>
                <button-cta v-if="isAdmin || props.item.actions" title="confirm" data-modalType="deleteEncodingProfile" :data-modalID="props.item.id" :data-modalField="props.item.name" class="btn btn-danger btn-xs" :onClick="onLaunchModal">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button-cta>
              </span>
        </template>
      </slot-table>
      <hr>
      <h4>Default Encoding Profiles</h4>
      <slot-table :data="defaultEncodingProfiles" :columns="table.columns.default" class="epTable">
        <!--        <template slot="user" slot-scope="props">-->
        <!--          <router-link :to='`/user/${props.item.user.hash_id}/edit`'>-->
        <!--            {{ props.item.user.username}}-->
        <!--          </router-link>-->
        <!--        </template>-->
        <template slot="clients" slot-scope="props">
          {{ getNamesFromClientsData(props.item) }}
        </template>
        <template slot="actions" slot-scope="props">
              <span @mouseover="setActiveActionSlug (props.item.slug)">
                <button-cta v-if="isAdmin" data-modalType="assignEncodingProfileToClients" :data-modalID="props.item.id" :data-modalField="props.item.display_name" :onClick="(event) => launchAssignEPModal(event, props.item)" :theme="getAssignColor(props.item)" class="btn-xs">
                    <i :class="getAssignIcon(props.item)" aria-hidden="true"></i>
                </button-cta>
                <button-cta v-if="isAdmin || props.item.actions" data-modalType="editEncodingProfile" :data-modalID="props.item.id" :data-modalField="props.item.name" :data-modalFieldType="props.item.data" :onClick="onLaunchModal" class="btn btn-warning btn-xs">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                </button-cta>
                <button-cta data-modalType="cloneEncodingProfile" :data-modalID="props.item.id" :data-modalField="props.item.name" :onClick="onLaunchModal" class="btn btn-success btn-xs">
                    <i class="fa fa-clone" aria-hidden="true"></i>
                </button-cta>
                <button-cta v-if="isAdmin || props.item.actions" title="confirm" data-modalType="deleteEncodingProfile" :data-modalID="props.item.id" :data-modalField="props.item.name" class="btn btn-danger btn-xs" :onClick="onLaunchModal">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button-cta>
              </span>
        </template>
      </slot-table>
    </div>

    <portal to="globalModal">
      <modal-encoding-profile-confirm :show="showModal.deleteEncodingProfile" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('deleteEncodingProfile')"/>
      <modal-add-encoding-profile :show="showModal.addEncodingProfile" :type="modalType" :confirmId="modalId" :field="modalField" :fieldType="modalFieldType" @close="toggleModal('addEncodingProfile')"/>
      <modal-edit-encoding-profile :show="showModal.editEncodingProfile" :slugField="activeActionSlug" :type="modalType" :confirmId="modalId" :field="modalField" :fieldType="modalFieldType" @close="toggleModal('editEncodingProfile')"/>
      <modal-clone-encoding-profile :show="showModal.cloneEncodingProfile" :id="modalId" :name="modalField" @close="toggleModal('cloneEncodingProfile')"/>
      <modal-assign-encoding-profile-to-clients :show="showModal.assignEncodingProfileToClients" :id="modalId" :name="modalField" @close="toggleModal('assignEncodingProfileToClients')"/>
    </portal>

  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {encodingProfileMixin} from '@/mixins/encodingProfileMixin'
import {profileMixin} from '@/mixins/profileMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import ModalEncodingProfileConfirm from '@/components/Modal/encoding-profile/modal-encoding-profile-confirm'
import ModalEditEncodingProfile from '@/components/Modal/encoding-profile/modal-edit-encoding-profile'
import ModalAddEncodingProfile from '@/components/Modal/encoding-profile/modal-add-encoding-profile'
import ModalCloneEncodingProfile from '@/components/Modal/encoding-profile/modal-clone-encoding-profile'
import ModalAssignEncodingProfileToClients from '@/components/Modal/encoding-profile/modal-assign-encoding-profile-to-clients.vue'

export default {
  name: 'EncodingProfiles',
  mixins: [encodingProfileMixin, modalMixin, notificationMixin, profileMixin],
  components: {
    HeadingWrap,
    SlotTable,
    ButtonCta,
    Spinner,
    ModalEncodingProfileConfirm,
    ModalEditEncodingProfile,
    ModalAddEncodingProfile,
    ModalCloneEncodingProfile,
    ModalAssignEncodingProfileToClients
  },
  data: () => ({
    activeActionSlug: null,
    defaultEncodingProfiles: [],
    clientEncodingProfiles: [],
    associatedClientEncodingProfiles: [],
    table: {
      columns: {
        default: {
          display_name: 'Name',
          slug: 'Slug',
          data: 'FFMPEG Encoding Profile in JSON Format',
          '': '',
          actions: 'Actions'
        },
        client: {
          display_name: 'Name',
          slug: 'Slug',
          data: 'FFMPEG Encoding Profile in JSON Format',
          clients: 'Clients',
          actions: 'Actions'
        },
        associated_clients_eps: {
          display_name: 'Name',
          slug: 'Slug',
          data: 'FFMPEG Encoding Profile in JSON Format',
          clients: 'Clients',
          actions: 'Actions'
        }
      }
    }
  }),
  watch: {
    encodingProfiles () {
      this.defaultEncodingProfiles = []
      this.clientEncodingProfiles = []
      this.associatedClientEncodingProfiles = []
      this.encodingProfiles.forEach(ep => {
        if (ep && ep.associatedClientsEps) {
          this.associatedClientEncodingProfiles.push(ep)
        } else if (!ep.user) {
          this.defaultEncodingProfiles.push(ep)
        } else {
          this.clientEncodingProfiles.push(ep)
        }
      })
    }
  },
  computed: {
    isAdmin () {
      return this.profileUser.role === 1
    }
  },
  methods: {
    setActiveActionSlug (slug) {
      this.activeActionSlug = slug
    },
    getNamesFromClientsData (item, imp = false) {
      if (!item.user && !imp) {
        return
      }
      let clients = item.clients
      let names = ''
      if (Array.isArray(clients)) {
        clients.forEach((client, index) => {
          names += `${client.name}`
          if (index < clients.length - 1) {
            names += ', '
          }
        })
      }
      return names
    },
    launchAssignEPModal (e, ep) {
      if (this.profileUser.clients.length === 1) {
        let clients = this.profileUser.clients
        if (ep.clients[0] && this.profileUser.clients[0] === ep.clients[0].hash_id) {
          clients = []
        }
        let id = ep.id
        if (!id) {
          this.addNotification('danger', 'Something Went Wrong')
          return
        }
        this.startLoading()
        let payload = {
          'id': id,
          'clients': clients
        }
        this.assignEncodingProfile(payload).then(() => {
          this.getEncodingProfiles().then(() => {
            this.addNotification('success', `Encoding Profiles Assigned to Clients successfully`)
            this.finishLoading()
          })
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
        this.close()
        return
      }
      this.onLaunchModal(e)
    },
    getAssignIcon (ep) {
      if (this.profileUser.clients.length === 1) {
        if (ep.clients[0] && this.profileUser.clients[0] === ep.clients[0].hash_id) {
          return 'fa fa-minus'
        }
      } else if (ep.clients.length > 0) {
        return 'fa fa-minus'
      }
      return 'fa fa-plus'
    },
    getAssignColor (ep) {
      if (this.profileUser.clients.length === 1) {
        if (ep.clients[0] && this.profileUser.clients[0] === ep.clients[0].hash_id) {
          return 'grey'
        }
      } else if (ep.clients.length > 0) {
        return 'grey'
      }
      return 'primary'
    }
  },
  created () {
    this.startLoading()
    this.getEncodingProfiles().then(() => {
      if (this.isAdmin) {
        this.table.columns.client = {
          display_name: 'Name',
          slug: 'Slug',
          data: 'FFMPEG Encoding Profile in JSON Format',
          clients: 'Clients',
          // user: 'Created By',
          actions: 'Actions'
        }
      }
      this.finishLoading()
    }, error => {
      this.finishLoading()
      this.addNotification('danger', error)
    })
  }
}
</script>

<style lang="scss">
.epTable {
  //Name
  th:nth-child(1), td:nth-child(1) {
    max-width: 12vw; min-width: 12vw;
    word-break: break-word;
  }
  //Slug
  th:nth-child(2), td:nth-child(2) {
    max-width: 13vw; min-width: 13vw;
    word-break: break-word;
  }
  //Data
  th:nth-child(3), td:nth-child(3) {
    max-width: 43vw; min-width: 43vw;
    word-break: break-word;
  }
  //Clients
  th:nth-child(4), td:nth-child(4) {
    max-width: 15vw; min-width: 15vw;
    word-break: break-word;
  }
  //Actions
  th:nth-child(5), td:nth-child(5) {
    max-width: 12vw; min-width: 12vw;
    text-align: center;
  }
  .btn-grey {
    color: #fff;
    background-color: #454545;
    border-color: #454545;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/encoding-profile/encoding-profiles.vue